import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../Store';
import { Graph_QL } from '../../../../Services';
import { useDeviceInfo } from '../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useDeviceInfo'
import { frames } from '../../../../Styles';
import { Overlay, PageHeader } from '../../../../Components';

// Table
import IoTable from '../../../../Components/Settings/ioTable';
import LcTable from '../../../../Components/Settings/lcTable';
import { Pages } from '../../../../Navigation/root';
import { useLanControllers } from '../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useLanControllers';

export default function Devices() {
  const { t } = useTranslation();
  const [editLCTable, setEditLCTable] = useState(false);
  const [editIOTable, setEditIOTable] = useState(false);
  
  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);;

  const { data: deviceInfoState, call: getDeviceInfo, maintainEntries: maintainDeviceInfo } = useDeviceInfo(connection);
  const { data: lanControllerState, call: getLanControllers, maintainEntries: maintainControllerInfo } = useLanControllers(connection);

  const deviceInfo = useMemo(() => {
    if (deviceInfoState[domain]) {
      return deviceInfoState[domain].data
    }
    return []
  },[deviceInfoState, domain])

  const lanControllerInfo = useMemo(() => {
    if (lanControllerState[domain]) {
      return lanControllerState[domain].data
    }
    return []
  },[domain, lanControllerState])

  useEffect(() => {
    getDeviceInfo({fetchAmount: 500}, connection);
    getLanControllers({ fetchAmount: 50, offset: 0 });
  },[connection])
  // #endregion

  return (
    <frames.Page_inner>
      {editLCTable ||editIOTable ? <Overlay overrides={{ }} beforeUnload onClickAlert /> : <></>}
      <PageHeader topHeader={t(`menuHeaders.${Pages.globalSettings}`, {defaultValue: "settings"})} subHeader={t(`menuHeaders.${Pages.devices}`, {defaultValue: "devices"})}/>
      <frames._page_inner_content>
        <div style={{height: "100%", width: "100%", gap: "20px", display: "grid", gridTemplateRows: "1fr 2fr", boxSizing: "border-box"}}>
          
          {/* LC Table */}
          <div style={{ gridArea: "1/1/2/2", overflow: "hidden"}}>
            <LcTable onEditTable={setEditLCTable} zIndex={editLCTable ? 9999 : undefined} lanControllerInfo={lanControllerInfo} maintainControllerInfo={maintainControllerInfo} />
          </div>

          {/* IO Table */}
          <div style={{gridArea: "2/1/3/2", overflow: "hidden"}}>
            <IoTable onEditTable={setEditIOTable} zIndex={editIOTable ? 9999 : undefined} deviceInfo={deviceInfo} maintainDeviceInfo={maintainDeviceInfo}/>
          </div>
        </div>
      </frames._page_inner_content>
    </frames.Page_inner>
  );
}